import ObjectId from 'bson-objectid';
import { Button, Clickable, Col, Icon, Modal } from 'components';
import { Api, theme } from 'lib';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

const ImageBg = styled.div`
  background-image: url(${(props) => props.imgUrl});
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.isMobile ? '100vw' : '80vh')};
  height: 80vh;
  background-repeat: no-repeat, repeat;
  background-position: center;
  background-size: contain;
`;

const CloseContainer = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
`;

const ImageModal = ({ visible, closeModal, chat, currentUserId, preview }) => {
  const [loading, setLoading] = useState(false),
    { isMobile } = useSelector((state) => state.appState),
    dispatch = useDispatch();

  async function sendImage() {
    setLoading(true);
    const msgId = ObjectId().toString();

    dispatch({
      type: 'NEW_MESSAGE',
      payload: {
        message: {
          createdAt: new Date().toString(),
          sender: currentUserId,
          file: visible,
          _id: msgId
        },
        chat
      }
    });

    closeModal();
    setLoading(false);

    let data = new FormData();
    const fileName = `${msgId}.${visible.type.split('/')[1]}`;

    data.append('image', visible, fileName);
    data.append('fileName', fileName);
    data.append('chatId', chat._id);
    data.append('msgId', msgId);

    await Api.post('/chats/send', data);
  }

  return (
    <Modal visible={visible} closeModal={closeModal} selfContent>
      <Col noFlex ht="100vh">
        <CloseContainer>
          <Clickable onClick={closeModal}>
            <Icon type="close" dimensions={isMobile ? 22.17 : 34.42} col={theme.SECONDARY_20} />
          </Clickable>
        </CloseContainer>

        <Col noFlex>
          <ImageBg
            isMobile={isMobile}
            imgUrl={visible && typeof visible === 'object' ? URL.createObjectURL(visible) : visible}
          />

          {preview && (
            <Col center marg="20px 0 0">
              <Button bg="#fff" bordered wid="300px" text="Send" onClick={sendImage} />
            </Col>
          )}
        </Col>
      </Col>
    </Modal>
  );
};

export default ImageModal;
